var jQuery = $;
import marquee from '../../node_modules/jquery.marquee/jquery.marquee.min.js';
import swiper from '../../node_modules/swiper/swiper-bundle.js';

const app = {
    /** Initialize */
    init() {

        // Init swiper
        this.initSwiperSliders();

        // Init Datalayer listeners for FAQ, Lessons and Age
        this.initDataLayers();

        // Fade sections in on scroll
        // this.fadeInOnScroll();

        // Toggle FAQ accordion
        this.toggleFaqItems();

        // Toggle times
        this.toggleTimes();

        // Smooth anchor
        this.smoothAnchor();

        // this.removeAndShowNavigationOnScroll();

        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger').on('click', $.proxy(this.toggleHamburgerMenu, this));
        $('.contact-button, .close-contact-popup').on('click', $.proxy(this.toggleContactoptions, this));

    },

    initDataLayers() {
        if ($('.section.accordion').length) {
            $('.section.accordion .accordions .column .accordion-item').on('click', function () {
                if (!$(this).find('.arrow-wrapper').hasClass('up')) {
                    return;
                }

                window.dataLayer = window.dataLayer || [];

                if ($(this).closest('.section.accordion').attr('id') == 'dl-lessons') {
                    window.dataLayer.push({
                        'event': 'info_leeftijd',
                        'informatie': $(this).find('.accordion-heading h3').text()
                    });
                } else if ($(this).closest('.section.accordion').attr('id') == 'dl-faq') {
                    window.dataLayer.push({
                        'event': 'FAQ',
                        'question': $(this).find('.accordion-heading h3').text()
                    });
                }
            });
        }

        if ($('.age-select-wrapper').length) {
            $('.age-select-wrapper').on('change', function () {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'leeftijd_kind',
                    'age': $(this).find('option:selected').text(),
                });
            });
        }
    },

    /** Handles the scroll event */
    windowScrollHandler() {
        $('header').toggleClass('scrolled', $(window).scrollTop() > 0);
    },

    /** Open hamburger menu */
    toggleHamburgerMenu() {
        $("header").toggleClass('open');
        $(".hamburger").toggleClass('active');
        $("nav.navigation").toggleClass('visible');
        // $(".navigation-bg").toggleClass('active');
        $("body").toggleClass('lock');
    },

    initSwiperSliders() {
        const imagesSlider = new Swiper('.images-slider-wrapper', {
            slidesPerView: 1.8,
            loop: true,
            spaceBetween: 25,
            grabCursor: true,
            breakpoints: {
                480: {
                    slidesPerView: 1.1,
                },
                768: {
                    slidesPerView: 3.35,
                },
                1024: {
                    slidesPerView: 3.35,
                    spaceBetween: 40,
                }
            },
        });

        const swiperOneReviewslider = new Swiper('.one-review .reviews-wrapper', {
            slidesPerView: 1,
            loop: true,
            grabCursor: true,
            effect: 'fade',
            autoplay: {
                delay: 10000,
            },
        });

        const swiperTwoReviewsslider = new Swiper('.two-reviews .reviews-wrapper', {
            slidesPerView: 1.3,
            loop: true,
            spaceBetween: 25,
            grabCursor: true,
            breakpoints: {
                480: {
                    slidesPerView: 1.1,
                },
                768: {
                    slidesPerView: 1.4,
                },
                1024: {
                    slidesPerView: 1.7,
                    spaceBetween: 30,
                },
                1280: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                1700: {
                    slidesPerView: 3.2,
                    spaceBetween: 30,
                },
            },
        });

        const swiperThreeReviewsslider = new Swiper('.three-reviews .reviews-wrapper', {
            slidesPerView: 1.3,
            loop: true,
            spaceBetween: 25,
            grabCursor: true,
            breakpoints: {
                480: {
                    slidesPerView: 1.1,
                },
                768: {
                    slidesPerView: 1.4,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                1280: {
                    slidesPerView: 2.4,
                    spaceBetween: 30,
                }
            },
        });
    },

    // Smooth anchor
    smoothAnchor() {
        var $root = $('html, body');

        $('a[href^="#"]:not(.open-popup)').click(function (e) {
            if ($(this).attr('href') !== '#reservation' && $(this).attr('href') !== '#') {

                e.preventDefault();
                $root.animate({
                    scrollTop: $($.attr(this, 'href')).offset().top - 0
                }, 500);

                return false;
            } else {
                e.preventDefault();
            }
        });
    },

    /** Open FAQ accordion */
    toggleFaqItems() {
        $(".toggle-heading").on("click", function () {
            if ($(this).parent().find(".toggle-content").hasClass("hidden")) {
                $(this).parent().find(".toggle-content.hidden").slideDown(500);
                $(this).parent().find(".toggle-content.hidden").removeClass("hidden");
                $(this)
                    .find(".arrow-wrapper")
                    .removeClass("down")
                    .addClass("up");
            } else {
                $(this).parent().find(".toggle-content").slideUp(500);
                $(this).parent().find(".toggle-content").addClass("hidden");
                $(this)
                    .find(".arrow-wrapper")
                    .removeClass("up")
                    .addClass("down");
            }
        });
    },

    /** Fade sections in on scroll */
    // fadeInOnScroll() {
    //     $.fn.initFadeIn = function () {
    //         $('.section').each(function () {
    //             let top_of_element = $(this).offset().top + 150;
    //             let bottom_of_element = $(this).offset().top + $(this).outerHeight();
    //             let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    //             let top_of_screen = $(window).scrollTop();
    //             if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) && !$(this).hasClass('is-visible')) {
    //                 $(this).addClass('is-visible');
    //             }
    //         });
    //     };
    //     $.fn.initFadeIn();
    //     $(window).scroll(function () {
    //         $.fn.initFadeIn();
    //     });
    // },

    // removeAndShowNavigationOnScroll() {

    //     var lastScrollTopPosition;

    //     let header = document.getElementById('header');

    //     window.addEventListener('scroll', function () {
    //         let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    //         if (scrollTop > lastScrollTopPosition) {
    //             if (window.innerWidth > 1024) {
    //                 header.style.top = '-80px';
    //             } else {
    //                 header.style.top = '-70px';
    //             }
    //         } else {
    //             header.style.top = '0';
    //         }

    //         lastScrollTopPosition = scrollTop;
    //     });
    // },

    toggleTimes() {
        $('.age-select').on('change', function () {
            let group = $(this).find('option:selected').attr('data-group');
            let ageCategory = $(this).find('option:selected').attr('data-age-category');

            $('.cta-locations .times-wrapper').each(function () {
                if ($('.times-wrapper[data-group="' + group + '"]').length) {
                    let timesWrapperGroup = $(this).attr('data-group');
                    if (timesWrapperGroup != group) {
                        $(this).addClass('hidden');
                    } else {
                        if ($(this).hasClass('hidden')) {
                            $(this).removeClass('hidden');
                        }
                    }
                }
            });

            $('.book-button').each(function () {
                let new_url = $(this).attr('data-base-url') + '&age-group=' + group;
                $(this).attr('href', new_url);
            });

            $('.age-category').html(ageCategory);
        });
    }
};


$(document).ready($.proxy(app.init, app));
